// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LegalLayout_legalShell__Mfa\\+7 {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.LegalLayout_legalMain__xTnK- {
  width: min(100%, var(--base-container));
  margin: 0 auto;
  padding: 34px 40px 84px;
  flex: 1 1;
}

.LegalLayout_legalHero__WvExW {
  display: block;
  margin-bottom: 18px;
}

.LegalLayout_legalCard__dqvC6,
.LegalLayout_legalSection__YXche {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 28px;
  box-shadow: 0 18px 48px rgba(18, 34, 29, 0.045);
}

.LegalLayout_legalCard__dqvC6 {
  padding: 34px;
}

.LegalLayout_legalMeta__NXl81 {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  margin: 0 0 16px;
  color: #5E806C;
  font-size: 12px;
  font-weight: 750;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.LegalLayout_legalMeta__NXl81 span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.LegalLayout_legalTitle__m93De {
  margin: 0;
  max-width: 920px;
  font-size: clamp(34px, 4.8vw, 58px);
  line-height: 0.98;
  letter-spacing: -0.05em;
  color: #13231D;
}

.LegalLayout_legalLead__nbkJO {
  margin: 18px 0 0;
  max-width: 780px;
  font-size: 17px;
  line-height: 1.72;
  color: #41515B;
}

.LegalLayout_legalAnchorNav__eHtsU {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 22px;
}

.LegalLayout_legalAnchorNav__eHtsU a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  padding: 0 16px;
  border-radius: 16px;
  border: 1px solid rgba(130, 177, 148, 0.34);
  background: #FBFBF8;
  font-size: 14px;
  font-weight: 700;
  color: #13231D;
  text-decoration: none;
  transition: all 0.2s ease;
}

.LegalLayout_legalAnchorNav__eHtsU a:hover,
.LegalLayout_legalAnchorNav__eHtsU a.LegalLayout_active__3Wq-k {
  color: #5E806C;
  border-color: #5E806C;
}

.LegalLayout_legalContent__jmPAA {
  display: grid;
  gap: 18px;
}

@media (max-width: 960px) {
  .LegalLayout_legalMain__xTnK- {
    width: min(100% - 32px, 760px);
    padding: 26px 0 56px;
  }
  .LegalLayout_legalCard__dqvC6,
  .LegalLayout_legalSection__YXche {
    padding: 24px;
  }
  .LegalLayout_legalAnchorNav__eHtsU {
    margin-top: 18px;
  }
}
.LegalLayout_legalSection__YXche {
  padding: 30px;
}
.LegalLayout_legalSection__YXche h2 {
  margin: 0 0 18px;
  font-size: 30px;
  line-height: 1.08;
  letter-spacing: -0.04em;
  color: #13231D;
}
.LegalLayout_legalSection__YXche h3 {
  margin: 20px 0 10px;
  font-size: 20px;
  line-height: 1.18;
  letter-spacing: -0.03em;
  color: #13231D;
}
.LegalLayout_legalSection__YXche p,
.LegalLayout_legalSection__YXche li {
  color: #364651;
  font-size: 15px;
  line-height: 1.78;
}
.LegalLayout_legalSection__YXche p {
  margin: 0 0 14px;
}
.LegalLayout_legalSection__YXche ul {
  margin: 0 0 12px;
  padding-left: 18px;
}
.LegalLayout_legalSection__YXche a {
  color: #5E806C;
  text-decoration: none;
  font-weight: 600;
}
.LegalLayout_legalSection__YXche a:hover {
  text-decoration: underline;
}
.LegalLayout_legalSection__YXche a.LegalLayout_legalBtn__EjO1A,
.LegalLayout_legalSection__YXche .LegalLayout_legalBtn__EjO1A {
  color: #13231D;
  font-weight: 700;
  text-decoration: none;
}
.LegalLayout_legalSection__YXche a.LegalLayout_legalBtn__EjO1A:hover,
.LegalLayout_legalSection__YXche .LegalLayout_legalBtn__EjO1A:hover {
  color: #5E806C;
  border-color: #5E806C;
  text-decoration: none;
}

.LegalLayout_legalSectionAnchor__2cyRu {
  scroll-margin-top: 118px;
}

.LegalLayout_legalTable__qXgZR {
  display: grid;
  gap: 12px;
  margin: 18px 0;
}

.LegalLayout_legalRow__RJSd3 {
  display: grid;
  grid-template-columns: minmax(170px, 220px) minmax(0, 1fr);
  gap: 16px;
  padding: 16px 18px;
  border-radius: 18px;
  background: #FBFBF8;
  border: 1px solid rgba(16, 25, 21, 0.08);
}
.LegalLayout_legalRow__RJSd3 strong {
  font-size: 14px;
  line-height: 1.55;
  color: #13231D;
}
.LegalLayout_legalRow__RJSd3 div {
  color: #364651;
  font-size: 14px;
  line-height: 1.7;
}
@media (max-width: 960px) {
  .LegalLayout_legalRow__RJSd3 {
    grid-template-columns: 1fr;
  }
}

.LegalLayout_legalNote__EPwcH {
  padding: 16px 18px;
  border-radius: 18px;
  background: #F8F6F2;
  border: 1px solid rgba(130, 177, 148, 0.18);
  color: #41515B;
  font-size: 14px;
  line-height: 1.72;
  margin: 20px 0;
}
.LegalLayout_legalNote__EPwcH strong {
  color: #13231D;
}

.LegalLayout_legalActions__QRh\\+J {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 18px;
  margin-bottom: 0;
}

.LegalLayout_legalBtn__EjO1A,
.LegalLayout_legalSection__YXche a.LegalLayout_legalBtn__EjO1A,
.LegalLayout_legalSection__YXche .LegalLayout_legalBtn__EjO1A {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 16px;
  border-radius: 16px;
  border: 1px solid rgba(130, 177, 148, 0.34);
  background: #FBFBF8;
  font-size: 14px;
  font-weight: 700;
  color: #13231D;
  text-decoration: none;
  transition: all 0.2s ease;
  line-height: 1;
}
.LegalLayout_legalBtn__EjO1A:hover,
.LegalLayout_legalSection__YXche a.LegalLayout_legalBtn__EjO1A:hover,
.LegalLayout_legalSection__YXche .LegalLayout_legalBtn__EjO1A:hover {
  color: #5E806C;
  border-color: #5E806C;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/layouts/LegalLayout/LegalLayout.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EAEE,uCAAA;EACA,cAAA;EACA,uBAAA;EACA,SAAA;AAAF;;AAGA;EACE,cAAA;EACA,mBAAA;AAAF;;AAGA;;EAEE,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,+CAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAAF;;AAGA;EACE,SAAA;EACA,gBAAA;EACA,mCAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,2CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;AAAF;;AAGA;;EAEE,cAAA;EACA,qBAAA;AAAF;;AAGA;EACE,aAAA;EACA,SAAA;AAAF;;AAGA;EACE;IACE,8BAAA;IACA,oBAAA;EAAF;EAGA;;IAEE,aAAA;EADF;EAIA;IACE,gBAAA;EAFF;AACF;AAKA;EACE,aAAA;AAHF;AAKE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAHJ;AAME;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAJJ;AAOE;;EAEE,cAAA;EACA,eAAA;EACA,iBAAA;AALJ;AAQE;EACE,gBAAA;AANJ;AASE;EACE,gBAAA;EACA,kBAAA;AAPJ;AAUE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AARJ;AAUI;EACE,0BAAA;AARN;AAYE;;EAEE,cAAA;EACA,gBAAA;EACA,qBAAA;AAVJ;AAYI;;EACE,cAAA;EACA,qBAAA;EACA,qBAAA;AATN;;AAcA;EACE,wBAAA;AAXF;;AAcA;EACE,aAAA;EACA,SAAA;EACA,cAAA;AAXF;;AAcA;EACE,aAAA;EACA,0DAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wCAAA;AAXF;AAaE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAXJ;AAcE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAZJ;AAeE;EArBF;IAsBI,0BAAA;EAZF;AACF;;AAeA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAZF;AAcE;EACE,cAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AAbF;;AAgBA;;;EAGE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,2CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AAbF;AAeE;;;EACE,cAAA;EACA,qBAAA;EACA,qBAAA;AAXJ","sourcesContent":[".legalShell {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.legalMain {\n  // width: min(100%, 1200px);\n  width: min(100%, var(--base-container));\n  margin: 0 auto;\n  padding: 34px 40px 84px;\n  flex: 1;\n}\n\n.legalHero {\n  display: block;\n  margin-bottom: 18px;\n}\n\n.legalCard,\n.legalSection {\n  background: #F7F5F1;\n  border: 1px solid rgba(16, 25, 21, .08);\n  border-radius: 28px;\n  box-shadow: 0 18px 48px rgba(18, 34, 29, .045);\n}\n\n.legalCard {\n  padding: 34px;\n}\n\n.legalMeta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 14px;\n  margin: 0 0 16px;\n  color: #5E806C;\n  font-size: 12px;\n  font-weight: 750;\n  letter-spacing: .1em;\n  text-transform: uppercase;\n}\n\n.legalMeta span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.legalTitle {\n  margin: 0;\n  max-width: 920px;\n  font-size: clamp(34px, 4.8vw, 58px);\n  line-height: .98;\n  letter-spacing: -.05em;\n  color: #13231D;\n}\n\n.legalLead {\n  margin: 18px 0 0;\n  max-width: 780px;\n  font-size: 17px;\n  line-height: 1.72;\n  color: #41515B;\n}\n\n.legalAnchorNav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 22px;\n}\n\n.legalAnchorNav a {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 42px;\n  padding: 0 16px;\n  border-radius: 16px;\n  border: 1px solid rgba(130, 177, 148, .34);\n  background: #FBFBF8;\n  font-size: 14px;\n  font-weight: 700;\n  color: #13231D;\n  text-decoration: none;\n  transition: all 0.2s ease;\n}\n\n.legalAnchorNav a:hover,\n.legalAnchorNav a.active {\n  color: #5E806C;\n  border-color: #5E806C;\n}\n\n.legalContent {\n  display: grid;\n  gap: 18px;\n}\n\n@media (max-width: 960px) {\n  .legalMain {\n    width: min(100% - 32px, 760px);\n    padding: 26px 0 56px;\n  }\n\n  .legalCard,\n  .legalSection {\n    padding: 24px;\n  }\n\n  .legalAnchorNav {\n    margin-top: 18px;\n  }\n}\n\n.legalSection {\n  padding: 30px;\n\n  h2 {\n    margin: 0 0 18px;\n    font-size: 30px;\n    line-height: 1.08;\n    letter-spacing: -.04em;\n    color: #13231D;\n  }\n\n  h3 {\n    margin: 20px 0 10px;\n    font-size: 20px;\n    line-height: 1.18;\n    letter-spacing: -.03em;\n    color: #13231D;\n  }\n\n  p,\n  li {\n    color: #364651;\n    font-size: 15px;\n    line-height: 1.78;\n  }\n\n  p {\n    margin: 0 0 14px;\n  }\n\n  ul {\n    margin: 0 0 12px;\n    padding-left: 18px;\n  }\n\n  a {\n    color: #5E806C;\n    text-decoration: none;\n    font-weight: 600;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  a.legalBtn,\n  .legalBtn {\n    color: #13231D;\n    font-weight: 700;\n    text-decoration: none;\n\n    &:hover {\n      color: #5E806C;\n      border-color: #5E806C;\n      text-decoration: none;\n    }\n  }\n}\n\n.legalSectionAnchor {\n  scroll-margin-top: 118px;\n}\n\n.legalTable {\n  display: grid;\n  gap: 12px;\n  margin: 18px 0;\n}\n\n.legalRow {\n  display: grid;\n  grid-template-columns: minmax(170px, 220px) minmax(0, 1fr);\n  gap: 16px;\n  padding: 16px 18px;\n  border-radius: 18px;\n  background: #FBFBF8;\n  border: 1px solid rgba(16, 25, 21, 0.08);\n\n  strong {\n    font-size: 14px;\n    line-height: 1.55;\n    color: #13231D;\n  }\n\n  div {\n    color: #364651;\n    font-size: 14px;\n    line-height: 1.7;\n  }\n\n  @media (max-width: 960px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.legalNote {\n  padding: 16px 18px;\n  border-radius: 18px;\n  background: #F8F6F2;\n  border: 1px solid rgba(130, 177, 148, .18);\n  color: #41515B;\n  font-size: 14px;\n  line-height: 1.72;\n  margin: 20px 0;\n\n  strong {\n    color: #13231D;\n  }\n}\n\n.legalActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 18px;\n  margin-bottom: 0;\n}\n\n.legalBtn,\n.legalSection a.legalBtn,\n.legalSection .legalBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  padding: 0 16px;\n  border-radius: 16px;\n  border: 1px solid rgba(130, 177, 148, 0.34);\n  background: #FBFBF8;\n  font-size: 14px;\n  font-weight: 700;\n  color: #13231D;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  line-height: 1;\n\n  &:hover {\n    color: #5E806C;\n    border-color: #5E806C;\n    text-decoration: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legalShell": `LegalLayout_legalShell__Mfa+7`,
	"legalMain": `LegalLayout_legalMain__xTnK-`,
	"legalHero": `LegalLayout_legalHero__WvExW`,
	"legalCard": `LegalLayout_legalCard__dqvC6`,
	"legalSection": `LegalLayout_legalSection__YXche`,
	"legalMeta": `LegalLayout_legalMeta__NXl81`,
	"legalTitle": `LegalLayout_legalTitle__m93De`,
	"legalLead": `LegalLayout_legalLead__nbkJO`,
	"legalAnchorNav": `LegalLayout_legalAnchorNav__eHtsU`,
	"active": `LegalLayout_active__3Wq-k`,
	"legalContent": `LegalLayout_legalContent__jmPAA`,
	"legalBtn": `LegalLayout_legalBtn__EjO1A`,
	"legalSectionAnchor": `LegalLayout_legalSectionAnchor__2cyRu`,
	"legalTable": `LegalLayout_legalTable__qXgZR`,
	"legalRow": `LegalLayout_legalRow__RJSd3`,
	"legalNote": `LegalLayout_legalNote__EPwcH`,
	"legalActions": `LegalLayout_legalActions__QRh+J`
};
export default ___CSS_LOADER_EXPORT___;
